<section class="lg-container">
  <form [formGroup]="settingsForm"
        ccScrollToFirstInvalidField
        class="flex-direction-column no-projects"
        [ngClass]="{ 'no-projects': !projectsExists }"
        layout>
    <cc-box>
      <div class="lg-container" header box>{{'LEAD_GENERATION.GLOBAL_SETTINGS.TITLE' | translate }}</div>
      <div content box>
        <div class="lg-container flex-between align-item-center">
          <label class="w-45">{{'LEAD_GENERATION.GLOBAL_SETTINGS.DISPLAY_LIMIT_DESCRIPTION' | translate }}</label>
          <div class="w-30 flex-between">
            <div class="input-error">
              <input type="number"
                     min="0"
                     max="999"
                     formControlName="popupDisplayLimit">
              <cc-input-errors
                [form]="settingsForm"
                inputName="popupDisplayLimit"
                [errors]="[{'min': 'LEAD_GENERATION.MIN_VALUE' | translate:{ value: minValue }},
                           {'max': 'LEAD_GENERATION.MAX_VALUE' | translate:{ value: maxValue }}]">
              </cc-input-errors>
            </div>
          </div>
        </div>
        <cc-ip-exclusion
          [globalSettings]="globalSettings"
          [formGroup]="settingsForm"
        >
        </cc-ip-exclusion>
        <div class="divider" translate>{{'LEAD_GENERATION.DAILY_SUMMARY' | translate }}</div>
        <div class="lg-container border-top">
          <label>{{'LEAD_GENERATION.DAILY_SUMMARY_ENABLED' | translate}}</label>
          <ui-switch formControlName="dailySummaryEnabled" class="pull-right custom"></ui-switch>
        </div>

      <div class="lg-container flex-between align-item-center border-top" *ngIf="isDailySummaryEnabled">
        <label class="w-45">{{'LEAD_GENERATION.DAILY_SUMMARY_TIME_ZONE' | translate}}</label>
        <div class="w-30">
            <cc-timezones-dropdown
              [formControl]="settingsForm.get('dailySummaryTimeZone')"
              [initial]="settingsForm.get('dailySummaryTimeZone').value"
            ></cc-timezones-dropdown>
        </div>

      </div>

      <div class="lg-container flex-between align-item-center border-top" *ngIf="isDailySummaryEnabled">
        <label class="w-45">{{'LEAD_GENERATION.EMAIL' | translate}}</label>
        <div class="w-30">
          <div class="input-error">
            <input type="email"
                   email
                   formControlName="dailySummaryEmail">
            <cc-input-errors
              [form]="settingsForm"
              inputName="dailySummaryEmail"
              [errors]="[{'email': 'LEAD_GENERATION.ENTER_VALID_EMAIL' | translate}]">
            </cc-input-errors>
          </div>
        </div>
      </div>

      <div class="divider">{{'LEAD_GENERATION.NEW_LEAD' | translate }}</div>

      <div class="lg-container border-top">
        <label>{{'LEAD_GENERATION.NEW_LEAD_EMAIL_ENABLED' | translate }}</label>
        <ui-switch formControlName="newLeadEmailEnabled" class="pull-right custom"></ui-switch>
      </div>

      <div class="lg-container flex-between align-item-center border-top" *ngIf="isNewLeadEmailEnabled">
        <label class="w-45">{{'LEAD_GENERATION.EMAIL' | translate }}</label>
        <div class="w-30">
          <div class="input-error">
            <input type="email"
                   email
                   formControlName="newLeadEmail">
            <cc-input-errors
              [form]="settingsForm"
              inputName="newLeadEmail"
              [errors]="[{'email': 'LEAD_GENERATION.ENTER_VALID_EMAIL' | translate}]">
            </cc-input-errors>
          </div>
        </div>
      </div>

      <div class="lg-container border-top">
        <label>{{'LEAD_GENERATION.NEW_LEAD_SMS_ENABLED' | translate}}</label>
        <span class="z-index-10 tooltip-wrap pos-rlt inline">
              <i class="material-icons t-minus-2 grey-text text-xs tooltip-hover-icon pos-rlt m-l-xs">help_outline</i>
              <span class="tooltip-cc box-border box-radius text-xs p-a-sm pos-abt min-w-200 _300 opacity-1" translate
                    [translateParams]="{value: globalSettings.smsLimit}">LEAD_GENERATION.SMS_LIMIT_INFO</span>
          </span>
        <ui-switch formControlName="newLeadSmsEnabled" class="pull-right custom"></ui-switch>
      </div>

        <div class="lg-container flex-between align-item-center border-top" *ngIf="isNewLeadSmsEnabled">
          <label class="w-45">{{'LEAD_GENERATION.PHONE_NUMBER' | translate}}</label>
          <div class="w-30 flex-between">
            <div class="input-error">
              <input type="text"
                     class="light-grey-placeholder"
                     formControlName="newLeadPhoneNumber"
                     [placeholder]="'LEAD_GENERATION.PHONE_NUMBER_PLACEHOLDER' | translate"
                     (keyup)="onPhoneNumberChange()">
              <cc-input-errors
                [form]="settingsForm"
                inputName="newLeadPhoneNumber"
                [errors]="[{'phoneNumber': 'LEAD_GENERATION.ENTER_VALID_PHONE_NUMBER' | translate}]">
              </cc-input-errors>
            </div>
            <button
              mat-raised-button
              (click)="onPhoneNumberVerify()"
              color="primary"
              class="m-l-1 w-min-90"
              [disabled]="isVerifiedPhoneNumber || !isValidPhoneNumber">
              {{ isVerifiedPhoneNumber ? ('VERIFIED' | translate) : isPhoneNumberVerificationSent ? ('RETRY' |
              translate) : ('VERIFY' | translate) }}
            </button>
          </div>
        </div>

      <div class="lg-container flex-between align-item-center border-top"
           *ngIf="isNewLeadSmsEnabled && isPhoneNumberVerificationSent">
        <label class="w-45">{{'ORDER_NUMBER.ENTER_CODE' | translate}}</label>
        <div class="w-50 flex-between">
          <cc-verify-code
            [verifyCodeLength]="4"
            [invalid]="''"
            (changed)="onVerificationCodeChange($event)"
          ></cc-verify-code>
          <button
            mat-raised-button
            (click)="onPhoneNumberVerificationCodeVerify()"
            color="primary"
            class="m-l-1">
            {{ 'ORDER_NUMBER.CONFIRM' | translate }}
          </button>
        </div>
      </div>

        <div class="divider" translate>{{'LEAD_GENERATION.GLOBAL_SETTINGS.INTEGRATIONS' | translate }}</div>
        <div class="lg-container border-top">
          <label>{{'LEAD_GENERATION.GLOBAL_SETTINGS.GOOGLE_ANALYTICS' | translate}}</label>
          <ui-switch formControlName="googleAnalyticsEnabled" class="pull-right custom"></ui-switch>
        </div>

        <div class="lg-container flex-between align-item-center border-top" *ngIf="isGoogleAnalyticsIntegrationEnabled">
          <label class="w-45">{{'LEAD_GENERATION.GLOBAL_SETTINGS.UA_TRACKER_ID' | translate}}</label>
          <div class="w-30">
            <div class="input-error">
              <input type="text" formControlName="googleAnalyticsUaTrackerId">
              <cc-input-errors
                [form]="settingsForm"
                inputName="googleAnalyticsUaTrackerId"
                [errors]="[{'pattern': 'LEAD_GENERATION.GLOBAL_SETTINGS.ENTER_VALID_UA_TRACKER_ID' | translate}]">
              </cc-input-errors>
            </div>
          </div>
        </div>

        <div class="google-analytics grey-100" *ngIf="isGoogleAnalyticsIntegrationEnabled">
          <p class="f-s-16">
            <i class="material-icons green-text pos-rlt m-r-xs">help_outline</i>
            <span translate>LEAD_GENERATION.GLOBAL_SETTINGS.GOOGLE_ANALYTICS_HEADER</span>
          </p>
          <span class="description" [innerHTML]="'LEAD_GENERATION.GLOBAL_SETTINGS.GOOGLE_ANALYTICS_DESCRIPTION' | translate"></span>
        </div>

        <div class="google-analytics grey-100" *ngIf="isGoogleAnalyticsIntegrationEnabled">
          <p class="f-s-16">
            <i class="material-icons green-text pos-rlt m-r-xs">help_outline</i>
            <span translate>LEAD_GENERATION.GLOBAL_SETTINGS.GOOGLE_ANALYTICS_HEADER_2</span>
          </p>
          <div class="description">
            <span [innerHTML]="'LEAD_GENERATION.GLOBAL_SETTINGS.GOOGLE_ANALYTICS_DESCRIPTION_BUBBLE' | translate" class="m-r-lg"></span>
            <span [innerHTML]="'LEAD_GENERATION.GLOBAL_SETTINGS.GOOGLE_ANALYTICS_DESCRIPTION_POPUP' | translate"></span>
          </div>
        </div>

        <div class="button-wrapper w-min-90">
        <button
          mat-raised-button
          (click)="onSubmit()"
          color="primary-full">
          {{ 'LEAD_GENERATION.GLOBAL_SETTINGS.SAVE' | translate }}
        </button>
      </div>
    </div>
  </cc-box>
</form>
</section>
